import { PurchaseRequisition } from '@/generated/gql/graphql';

export enum PurchaseRequisitionDataGridField {
  EXTERNAL_ID = 'externalId',
  DESCRIPTION = 'description',
  TYPE = 'type',
  LINE_ITEMS_COUNT = 'lineItemsCount',
  PREFERRED_SUPPLIERS_COUNT = 'preferredSuppliersCount',
  FIXED_SUPPLIERS_COUNT = 'fixedSuppliersCount',
  TOTAL_VALUE = 'totalValue',
  IS_BLOCKED = 'isBlocked',
  LINKS = 'links',
  PRIMARY_COMMODITY_GROUP = 'primaryCommodityGroup',
  COMMODITY_GROUP_LIST = 'commodityGroupList',
  COMMODITY_GROUP_COUNT = 'commodityGroupCount',
}

export enum PurchaseRequisitionDataGridColumnGroup {
  SUPPLIER = 'supplier',
  PURCHASE_REQUISITION = 'purchaseRequisition',
}

export type PurchaseRequisitionDataGridRow = PurchaseRequisition;
